import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCreditTier } from "@/api/creditTiers";
import { CreditTiersQueryKeys } from "@/tanstackQuery/queries/creditTiers";

export interface CreateCreditTierOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useCreateCreditTier = (options?: CreateCreditTierOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCreditTier,
    onSuccess(data) {
      queryClient.invalidateQueries({
        queryKey: [CreditTiersQueryKeys.All],
      });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
};
